import type { AdminAiKindStats } from '@b4b/shared';

export function formatPercent(fraction: number, locale: string): string {
  return new Intl.NumberFormat(locale, { style: 'percent', maximumFractionDigits: 0 }).format(fraction);
}

export function formatUsd(value: number, locale: string): string {
  const digits = value < 1 ? 4 : 2;
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: digits,
    maximumFractionDigits: digits,
  }).format(value);
}

export function formatMs(ms: number | null): string {
  if (ms == null) return '–';
  return ms >= 1000 ? `${(ms / 1000).toFixed(1)} s` : `${ms} ms`;
}

/** Locale-aware one-decimal number (e.g. reads/day averages) — `Number.toFixed` always uses
 * a dot and ignores the viewer's locale. */
export function formatDecimal(value: number, locale: string): string {
  return new Intl.NumberFormat(locale, { maximumFractionDigits: 1, minimumFractionDigits: 1 }).format(value);
}

/** Traffic light for one AI feature: off (disabled by env), ok (<5 % failed), warn (5–20 %),
 * bad (>20 % failed in the range, or enabled with zero calls in the last 24h).
 * `checkIdle` is false for junk_rules (CLI-only, run on demand — idleness is normal there;
 * see the caller in AiKindCards for the "off when zero calls in the range" special case). */
export function healthLevel(k: AdminAiKindStats, enabled: boolean, checkIdle = true): 'off' | 'ok' | 'warn' | 'bad' {
  if (!enabled) return 'off';
  if (checkIdle && k.calls24h === 0) return 'bad';
  if (k.calls === 0) return 'ok';
  const failedShare = k.failed / k.calls;
  if (failedShare > 0.2) return 'bad';
  if (failedShare >= 0.05) return 'warn';
  return 'ok';
}
